import React, {useState, useEffect} from 'react';
import Base64 from 'Base64';
import Typography from 'components/Typography';
import Resizer from "react-image-file-resizer";

import { Row, Col, Input, Card, CardHeader, CardBody, Modal, ModalHeader, ModalBody, Alert, FormGroup, Label, Button } from 'reactstrap';

import DataAdapter from "../../adapter/DataAdapter";
import ComboBox from "../../component/ComboBox";
import { Cookies } from 'react-cookie';

import TaskDetail from '../TaskDetails/TaskDetail.js';
import DateTime from '../../lib/DateTime.js';


const cookie =new Cookies();
const _BACKEND_URL_ = "https://node.renobuilding.ca:3001"

const getToday=()=>{
	var today = new Date();
	return today.getFullYear() + '-' + (today.getMonth()<9 ? '0'+(today.getMonth()+1) : today.getMonth()+1) + '-' + today.getDate();
	
}

function FormLog (props){
    const [isOpen, setIsOpen] 			= useState(true);
	
    const [selectedFile, setSelectedFile] 			= useState(null);
    const [department, setDepartment]	= useState(-1);
    const [parent, setParent] 						= useState(null);
	
    const [uploading, setUploading] 	= useState(false);
    const [alert, setAlert] 			= useState('');
	
    const [task_type, setTask_type]				= useState(-1);	
    const [lg_type, setLg_type]					= useState(1);	
    const [lg_desc, setLg_desc]					= useState('');
    const [prj_id, setPrj_id] 					= useState(-1);
    const [pt_id, setPt_id] 					= useState(0);
    const [pt_parent, setPt_parent]				= useState(0);
    const [prj_folder_id, setPrj_folder_id] 	= useState(0);
    const [image_id, setImage_id] 				= useState(0);
    const [receiver_id, setReceiver_id] 		= useState(-1);
    const [date, setDate]		 				= useState((new Date()).toISOString().split('T')[0]);
	
	useEffect(()=>{
		var _project	= props.project;
		if(_project && _project.prj_id != prj_id){
			setPrj_id(_project.prj_id);
			setPrj_folder_id(_project.prj_folder_id);
			findParent(_project.prj_folder_id);
			(new DataAdapter("SELECT receiver_id, pt_id FROM rb_project_tasks WHERE prj_id=" + _project.prj_id + " AND task_type=93;"))
			  .getRecords()
			  .then(data=>{
				  if(data[0]){
					setReceiver_id(data[0].receiver_id);
					setPt_parent(data[0].pt_id);
				  }
				   else
					setReceiver_id(-1);
			  });
		}
		if(props.type != lg_type){
			setLg_type(props.type);			
		}
	},[props]);
	
	const findParent = (_parent) => {
				setUploading(true);
				setAlert('');
				setParent(null);
				let requestOptions = {
					method: 'GET',
					headers: {
						'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
					}
				};
				fetch(_BACKEND_URL_ + '/search?fullText=' + (task_type*1==125?'Images':'Docs') + '&parent=' + _parent + '&mimeType=application/vnd.google-apps.folder', requestOptions)
				.then(response => {
				  return Promise.all([response.json(),response])
				})
				.then(([responseData,response]) => {
					setParent(responseData[0].id);
					setUploading(false);
				})
				.catch(error => {
					console.error('Error:', error);
				})			
	}
	const onFieldChangeHandler=(event)=>{
		event.persist();
		if(event.target.id === 'prj_id'){
			setPrj_id(event.target.value.split(',')[0]);
			setPrj_folder_id(event.target.value.split(',')[1]);
			if(event.target.value.split(',')[1]!=0){
				findParent(event.target.value.split(',')[1]);
			}else{
				setAlert('');
				setParent(null);
			}
			(new DataAdapter("SELECT receiver_id, pt_id FROM rb_project_tasks WHERE prj_id=" + event.target.value.split(',')[0] + " AND task_type=93;"))
			  .getRecords()
			  .then(data=>{
				  if(data[0]){
					setReceiver_id(data[0].receiver_id);
					setPt_parent(data[0].pt_id);
				  }
				   else
					setReceiver_id(-1);
			  });
		}
		if(event.target.id === 'task_type')
			setTask_type(event.target.value);
		if(event.target.id === 'lg_desc')
			setLg_desc(event.target.value);
		if(event.target.id === 'pt_id')
			setPt_id(event.target.value);
		if(event.target.id === 'receiver_id')
			setReceiver_id(event.target.value);
	}
	const onSubmitHandler=(e)=>{
		e.persist();
		setUploading(true);
		
		
		var _taskDetail = {
			parent					:	pt_parent, 
			pt_id					:	pt_id, 
			prj_id					:	prj_id, 
			task_type				:	task_type, 
			task_status				:	10, 
			sender_id				:	cookie.get("v-person-id"), 
			receiver_id				:	receiver_id,
			attachments				:	image_id,
			task_description		:	lg_desc.replaceAll('\n',' | '),
			start_date				:	date, 
			end_date				:	date
		};
		
		var taskDetail =new TaskDetail();
	
		taskDetail.insert(_taskDetail).then(data=>{
			setUploading(false);
			//this.addNotification("Note added", "info");
			//this.props.callback({...{callbackType : 'note'},...{response : data}});
			setIsOpen(false);
		});
  
	}
	const onFileChange = async (event) => {
		setSelectedFile(event.target.files);
		var fileName 	=	event.target.files[0].name;
		var newFileName	=	Date.now() + fileName.substring(fileName.lastIndexOf('.'));
		if(parent){
			setUploading(true);
			const image = await resizeFile(event.target.files[0]);
			
			const formData = new FormData()
			formData.append('myfile', image, newFileName);
		
			fetch(_BACKEND_URL_ + '/file?project=' + parent, {
			method: 'POST',
			body: formData
			})
			.then(response => response.json())
			.then(data => {
				setImage_id(data.data.id);
				setUploading(false);
				//this.addNotification('Image has been uploaded');
			})
			.catch(error => {
				console.error(error)
			});
		}else{
			setAlert(' Select Project!');
		}
		
	}; 
	const imageUpload =(files) =>{
		console.log(files[0]);
		/*
		for(var i=0; i < files.length ; i++){
			const formData = new FormData()
			formData.append('myfile', files[i]);
		
			fetch(_BACKEND_URL_ + '/file?project=' + parent, {
			method: 'POST',
			body: formData
			})
			.then(response => response.json())
			.then(data => {
				setImage_id(data.data.id);
				setUploading(false);
				//this.addNotification('Image has been uploaded');
			})
			.catch(error => {
			console.error(error)
			});
		}
		*/
	}
	const resizeFile = (file) => new Promise(resolve => {
		Resizer.imageFileResizer(file, 640, 480, 'JPEG', 100, 0,
		uri => {
		  resolve(uri);
		}, 'file' );
	});

	return (
		<>
			<Modal  isOpen={isOpen} >
				<ModalHeader>
					<Row>
						<Col>
							<span className=''>Send {lg_type==1? 'Log':'Purchase'}</span>
						</Col>
						<Col>						
							<button type="button" className="btn btn-primary btn-sm float-right ml-1 mr-1" onClick={(event)=>{
								setIsOpen(false);
								//props.callback({...{callbackType:'clockout'}, ...{response : [{pt_id: task.pt_id}]}});
								}
							} >X</button>{' '}
						</Col>
					</Row>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col md={12} sm={12} xs={12} >
							<Card>
								<CardBody>
								{uploading?
									  <Alert color="info">
										<Typography type="h6" className="alert-heading">
										  Please wait ...
										</Typography>
									 </Alert>
								:''}
									<FormGroup row >
										<Label for="pt_id" md={2} >Task Type</Label>
										<Col md={10}>
											<ComboBox id="task_type" onChange={onFieldChangeHandler} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"task_type' AND rb_type_type_id=4 AND 'x'='x"} orderby="rb_type_no"  defaultValue={task_type}  />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="department" md={2} >Department</Label>
										<Col md={10}>
											<ComboBox title="Department" onChange={async (e)=>{
												e.persist();
												setDepartment(e.target.value);
											}} table="rb_types" filterField="rb_type" filterValue={"prj_department' AND rb_type_type_id='1"} valueField="rb_type_no" displayField="rb_type_desc"  orderby="rb_type_no" defaultValue={department} />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={2} >Project</Label>
										<Col md={10}>
											<ComboBox onCallback={(_value)=>{
												setPrj_id(_value.split(',')[0]);
												setPrj_folder_id(_value.split(',')[1]);
												if(_value.split(',')[1]!=0){
													findParent(_value.split(',')[1]);
												}else{
													setAlert('');
													setParent(null);
												}
												(new DataAdapter("SELECT receiver_id, pt_id FROM rb_project_tasks WHERE prj_id=" + _value.split(',')[0] + " AND task_type=93;"))
												  .getRecords()
												  .then(data=>{
													  if(data[0]){
														setReceiver_id(data[0].receiver_id);
														setPt_parent(data[0].pt_id);
													  }
													   else
														setReceiver_id(-1);
												  });
												
											}} id="prj_id" onChange={onFieldChangeHandler}  table="rb_projects" valueField="prj_id,prj_folder_id" displayField="prj_code,prj_address" filterField="prj_department" filterValue={ department + "' AND prj_status IN (9,10) AND 'x'='x" } orderby="prj_code"  defaultValue={prj_id + ',' + prj_folder_id }  />
											{prj_id!=-1 && !parent? <font className="text-info" >Destination Folder Not Found</font>:''}
											{prj_id!=-1 && receiver_id*1==-1? <font className="text-warning" >Receiver Not Found</font>:''}
										</Col>
									</FormGroup>
									{parent && receiver_id*1!=-1?
									<>
										<FormGroup row >
											<Label for="image_id" md={2} >Send Image by</Label>
											<Col>
												<label htmlFor="formFile">
													<i className="btn btn-outline-secondary btn-sm" >Camera</i>
													<input className="form-control" style={{display: 'none'}}  type="file" id="formFile" onChange={onFileChange} accept="image/*" capture="capture"  data-original-title="upload photos" />
												</label>
											</Col>
											<Col>
												<label htmlFor="formFileMultiple">
													<i className="btn btn-outline-secondary btn-sm" >Gallery</i>
													<input className="form-control" style={{display: 'none'}}  type="file" id="formFileMultiple" onChange={onFileChange} accept="image/*" multiple data-original-title="upload photos" />
												</label>
											</Col>
										</FormGroup>									
										<FormGroup row >
											<Label for="lg_desc" md={2} >Descrption</Label>
											<Col md={10}>
												<Input type="textarea" name="lg_desc" id="lg_desc" onChange={onFieldChangeHandler} value={lg_desc} />
											</Col>
										</FormGroup>
										<FormGroup row >
											<Label for="date" md={2} >Date</Label>
											<Col md={10}>
												<Input type="date" onChange={(e)=> setDate(e.target.value)} value={date} />
											</Col>
										</FormGroup>
										<FormGroup check row>
											<Col>
												<Button className="float-right" onClick={onSubmitHandler} >Submit</Button>
											{/* image_id*1==0? '':
												<Button className="float-right" onClick={onSubmitHandler} >Submit</Button>
											*/} 
											</Col>
										</FormGroup>
									</>
									:''}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</ModalBody>
			</Modal>			
								
		</>
	);
}

export default FormLog;